import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ValueSection from './components/ValueSection';
import CategoriesSection from './components/CategoriesSection';
import WhySubscribe from './components/WhySubscribe';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const id = 'schema-home';
    if (!document.getElementById(id)) {
      const script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      script.text = JSON.stringify([
        {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'The BOLO Report',
          url: siteUrl,
          description:
            'Weekly reseller trend intelligence. Know which brands are selling fast, what to pay, and where to sell them. Published every Thursday.',
          potentialAction: {
            '@type': 'ReadAction',
            target: 'https://theboloreport.substack.com/',
          },
        },
        {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'The BOLO Report',
          url: siteUrl,
          sameAs: ['https://theboloreport.substack.com/'],
          description:
            'The BOLO Report is a weekly trend intelligence publication for resellers and entrepreneurs, identifying profitable resale opportunities every Thursday.',
          knowsAbout: [
            'reseller trend intelligence',
            'resale market data',
            'eBay reselling',
            'Poshmark trends',
            'Whatnot sourcing',
          ],
        },
        {
          '@context': 'https://schema.org',
          '@type': 'NewsMediaOrganization',
          name: 'The BOLO Report',
          url: siteUrl,
          description:
            'The BOLO Report is a weekly reseller trend intelligence newsletter published every Thursday, covering trending brands, resale value ranges, and marketplace insights.',
          publishingPrinciples: siteUrl,
          sameAs: ['https://theboloreport.substack.com/'],
        },
        {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'The BOLO Report | Reseller Trend Intelligence Newsletter',
          url: siteUrl,
          description:
            'The BOLO Report delivers weekly reseller trend intelligence every Thursday. Discover which brands are selling fast, what to pay, and where to sell for maximum profit on eBay, Poshmark, and Whatnot.',
          isPartOf: {
            '@type': 'WebSite',
            name: 'The BOLO Report',
            url: siteUrl,
          },
          about: {
            '@type': 'Thing',
            name: 'Reseller Trend Intelligence',
            description: 'Data-driven insights for resellers on eBay, Poshmark, and Whatnot.',
          },
        },
      ]);
      document.head.appendChild(script);
    }
    document.title = 'The BOLO Report | Reseller Trend Intelligence Newsletter';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'The BOLO Report delivers weekly reseller trend intelligence every Thursday. Discover which brands are selling fast, what to pay, and where to sell for maximum profit on eBay, Poshmark, and Whatnot.');
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <HeroSection />
        <WhySubscribe />
        <ValueSection />
        <CategoriesSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
